import React from "react";
import { FaMicrophone } from "react-icons/fa";

/**
 * Light blue "Tip." callout used at the end of the how-to sections. Same
 * surface as the explanatory callout on the Google Docs article: #EBF7FE fill,
 * 17.17px radius, 21.46px padding.
 */
const TipCallout = ({ children }) => (
  <div className="mt-[30.05px] flex items-start gap-[12.88px] rounded-[17.17px] border-[1.34px] border-[#3AB1F633] bg-[#EBF7FE] p-[16px] sm:p-[21.46px]">
    <span className="mt-[3px] flex text-[#3AB1F6]">
      <FaMicrophone className="h-[14px] w-[14px] shrink-0" />
    </span>

    <p className="font-jakarta text-[14px] font-normal leading-[24px] tracking-[0px] text-[#0A0D16B2]">
      <strong className="font-bold text-[#0A0D16]">Tip.</strong> {children}
    </p>
  </div>
);

export default TipCallout;
